import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';
import { Grip } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';

export function HeaderUserMenu() {
  const { t } = useTranslation('layout');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={t('header.userMenu.label')}
          className="relative"
        >
          <Grip className="w-5 h-5" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{t('header.userMenu.label')}</TooltipContent>
    </Tooltip>
  );
}
